import { get } from "lodash";
import { MdCheck, MdOpenInNew } from "react-icons/md";
import { COLORS } from "shared/style/colors";
import { CURRENCY_SYMBOL } from "utils/constants";
import { costToFrench } from "utils/helpers/values";
import Button from "../Button";

const ProductCard = ({
  planName,
  price,
  perMonth,
  info,
  action,
  isRecommended,
  links,
  translation,
  onHelpClick,
}) => {
  return (
    <div className={`pricing-lmf__card ${isRecommended ? "recommended" : ""}`}>
      {isRecommended && (
        <div className="recommendation-badge">Notre recommandation</div>
      )}
      <div className="pricing-lmf__card__header">
        <h3 className={`name__color--${isRecommended ? "white" : "primary"}`}>
          {planName}
        </h3>
        <div className="pricing-lmf__card__price">
          <div className={`price ${isRecommended && "recommended"} `}>
            <span className="amount">
              {costToFrench(price?.cost)}
              {CURRENCY_SYMBOL[price?.currency]}
              <span className="currency">
                {perMonth && <small> /mois</small>}
              </span>
            </span>
          </div>
          {/* <img src={isRecommended ? helpIconWhite : helpIcon} alt="help" onClick={() => onHelpClick()} /> */}
        </div>
        <Button
          type={isRecommended ? "white" : "primary"}
          onClick={action?.onClick}
          loading={action?.loading}
          disabled={action?.disabled}
          className="w-100 h-auto m-top-32"
          size="large"
        >
          {action?.label}
        </Button>
      </div>
      <div className="content">
        <div
          className={`pricing-lmf__card__benefits ${
            isRecommended && "recommended"
          } `}
        >
          <span className="title">{info?.title}</span>
          <ul className="list">
            {get(info, "items", [])
              .slice(0, 3)
              .map((item, index) => (
                <li key={index}>
                  <div className="icon">
                    <MdCheck color={COLORS.C_LMF_SECONDARY} size={20} />
                  </div>
                  <span>{item.mainInfo}</span>
                </li>
              ))}
          </ul>
        </div>
      </div>
      <div
        className={`pricing-lmf__card__footer ${
          isRecommended && "recommended"
        } `}
      >
        <span>{translation.COVERAGE_DETAIL}</span>
        {links?.map(({ label, onClick }, index) => (
          <>
            <span
              className="pricing-lmf__card__footer--link"
              key={label + index}
            >
              <span onClick={onClick}>{label}</span>
              <MdOpenInNew size={16} color={COLORS.C_LMF_SECONDARY} />
            </span>
          </>
        ))}
      </div>
    </div>
  );
};

export default ProductCard;
